import type { InjectionKey, Ref } from 'vue'

export const richInboxExpandedIdKey: InjectionKey<Ref<Maybe<string>>> =
  Symbol('richInboxExpandedId')
